// ============================================================
// ARCHIVO DE IMÁGENES - CAMBIA AQUÍ TODAS LAS FOTOS DEL SITIO
// ============================================================

// --- HERO (imágenes rotativas de la portada) ---
export const heroImage = "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/048cc5c8-7eed-46db-a933-f0054e283cef_WhatsApp-Image-2026-04-19-at-13.02.40.jpeg?v=f8f587870174cffb7fc8f2ad81282563";

export const heroImages = [
  "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/048cc5c8-7eed-46db-a933-f0054e283cef_WhatsApp-Image-2026-04-19-at-13.02.40.jpeg?v=f8f587870174cffb7fc8f2ad81282563",
  "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/52a65803-0678-4917-b8c6-a59addade467_WhatsApp-Image-2026-04-19-at-13.02.15.jpeg?v=e1e5be4be9bd25dbaacfd44fec6408fa",
  "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/1b7b32d0-0c79-42ee-a8d1-f52fd5fc64a2_WhatsApp-Image-2026-04-19-at-13.02.18.jpeg?v=86c735df6878fc0dfacdc0b3b7a2ca94",
  "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/0833919b-4dc5-4d55-8611-693d86abdc88_WhatsApp-Image-2026-04-19-at-13.02.30.jpeg?v=d3fdb328ef642f75c2227d51a87a7520",
  "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/d83258f2-7256-494c-a376-8faa94edf130_WhatsApp-Image-2026-04-19-at-13.02.32-1.jpeg?v=d07c9d137afa7da30cab61f990c5c2a1",
  "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/fe3cbe04-1749-46df-9b0a-176c81fccf93_WhatsApp-Image-2026-04-19-at-13.02.32.jpeg?v=1fd6b62d44c97165884b950b7ac11bbc",
  "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/97101e32-1956-486e-b6fc-7409cb929484_WhatsApp-Image-2026-04-19-at-13.02.33-1.jpeg?v=fab8c04c42232948dc501515bbbf8256",
  "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/bf3410c0-a40e-4b65-af3a-5cae1179d104_WhatsApp-Image-2026-04-19-at-13.02.33.jpeg?v=03984abba576550f3fed5f4edcb4087d",
  "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/ae1f4e2f-42b7-4665-8dfb-80ebd44e06f0_WhatsApp-Image-2026-04-19-at-13.02.34.jpeg?v=7c03ede0631e14f017f16d61f20d6047",
  "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/4ac39fd5-9c1d-4593-b54c-46719558ca76_WhatsApp-Image-2026-04-19-at-13.02.37.jpeg?v=feb2e02a02eb38ea77532533aadb37cd",
  "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/66344107-3c5d-4846-8618-950ff4ddaeb2_WhatsApp-Image-2026-04-19-at-13.02.39.jpeg?v=2440b40f7bf0d8100825265805578082",
];

// --- SOBRE NOSOTROS ---
export const aboutImage = "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/a9fb2644-8da6-4753-902b-84f0579878c7_WhatsApp-Image-2026-04-19-at-13.02.41.jpeg?v=994e43ab490d13efc84827d34c3f1748";

// --- SERVICIOS (6 fotos, una por servicio) ---
export const serviceImages = {
  construccion: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/b7b0d35c-941c-453b-978a-4b43e547b84c_WhatsApp-Image-2026-04-19-at-13.02.43.jpeg?v=75fbed48bc6f9cc33433848b7665e070",
  mantenimiento: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/5ed1bc31-0c50-4b5f-901e-b47650c8d307_WhatsApp-Image-2026-04-19-at-13.02.45-1.jpeg?v=31ae97189f151e669a1607af3733a6ee",
  limpieza: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/bde3eef3-0ce0-4a79-a4e5-4073b6c29ba8_WhatsApp-Image-2026-04-19-at-13.02.45.jpeg?v=398be6d2a922bece957f335767b71e00",
  reparacion: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/93ff6ac4-37e5-4a96-9147-b20d17c3130f_WhatsApp-Image-2026-04-19-at-13.02.46-1.jpeg?v=fdcf369afede8a87813c50a6982d8dff",
  depuradora: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/09325dd9-da40-43b0-873d-151cc09a81e9_WhatsApp-Image-2026-04-19-at-13.02.46.jpeg?v=5bfcc07e35fc9bc390ad640aea967c84",
  productos: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/b8afbff0-8fe8-4847-9c05-64c68f123441_WhatsApp-Image-2026-04-19-at-13.02.48.jpeg?v=4562a4f73818370a1f4ca4d59a58e2eb",
};

// --- GALERÍA (fotos y videos de trabajos realizados) ---
export const galleryImages = [
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/048cc5c8-7eed-46db-a933-f0054e283cef_WhatsApp-Image-2026-04-19-at-13.02.40.jpeg?v=f8f587870174cffb7fc8f2ad81282563",
    title: "Piscina Terminada",
    category: "Construcción",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/a9fb2644-8da6-4753-902b-84f0579878c7_WhatsApp-Image-2026-04-19-at-13.02.41.jpeg?v=994e43ab490d13efc84827d34c3f1748",
    title: "Proyecto Residencial",
    category: "Construcción",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/b7b0d35c-941c-453b-978a-4b43e547b84c_WhatsApp-Image-2026-04-19-at-13.02.43.jpeg?v=75fbed48bc6f9cc33433848b7665e070",
    title: "Construcción en Proceso",
    category: "Construcción",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/5ed1bc31-0c50-4b5f-901e-b47650c8d307_WhatsApp-Image-2026-04-19-at-13.02.45-1.jpeg?v=31ae97189f151e669a1607af3733a6ee",
    title: "Mantenimiento Profesional",
    category: "Mantenimiento",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/bde3eef3-0ce0-4a79-a4e5-4073b6c29ba8_WhatsApp-Image-2026-04-19-at-13.02.45.jpeg?v=398be6d2a922bece957f335767b71e00",
    title: "Limpieza y Tratamiento",
    category: "Mantenimiento",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/93ff6ac4-37e5-4a96-9147-b20d17c3130f_WhatsApp-Image-2026-04-19-at-13.02.46-1.jpeg?v=fdcf369afede8a87813c50a6982d8dff",
    title: "Reparación de Piscina",
    category: "Reparación",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/09325dd9-da40-43b0-873d-151cc09a81e9_WhatsApp-Image-2026-04-19-at-13.02.46.jpeg?v=5bfcc07e35fc9bc390ad640aea967c84",
    title: "Sistema de Depuración",
    category: "Instalación",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/b8afbff0-8fe8-4847-9c05-64c68f123441_WhatsApp-Image-2026-04-19-at-13.02.48.jpeg?v=4562a4f73818370a1f4ca4d59a58e2eb",
    title: "Productos y Accesorios",
    category: "Instalación",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/52a65803-0678-4917-b8c6-a59addade467_WhatsApp-Image-2026-04-19-at-13.02.15.jpeg?v=e1e5be4be9bd25dbaacfd44fec6408fa",
    title: "Piscina Familiar",
    category: "Construcción",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/1b7b32d0-0c79-42ee-a8d1-f52fd5fc64a2_WhatsApp-Image-2026-04-19-at-13.02.18.jpeg?v=86c735df6878fc0dfacdc0b3b7a2ca94",
    title: "Acabado Premium",
    category: "Construcción",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/0833919b-4dc5-4d55-8611-693d86abdc88_WhatsApp-Image-2026-04-19-at-13.02.30.jpeg?v=d3fdb328ef642f75c2227d51a87a7520",
    title: "Proyecto Completo",
    category: "Construcción",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/d83258f2-7256-494c-a376-8faa94edf130_WhatsApp-Image-2026-04-19-at-13.02.32-1.jpeg?v=d07c9d137afa7da30cab61f990c5c2a1",
    title: "Piscina con Escalera",
    category: "Construcción",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/fe3cbe04-1749-46df-9b0a-176c81fccf93_WhatsApp-Image-2026-04-19-at-13.02.32.jpeg?v=1fd6b62d44c97165884b950b7ac11bbc",
    title: "Diseño Moderno",
    category: "Construcción",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/97101e32-1956-486e-b6fc-7409cb929484_WhatsApp-Image-2026-04-19-at-13.02.33-1.jpeg?v=fab8c04c42232948dc501515bbbf8256",
    title: "Piscina Rectangular",
    category: "Construcción",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/bf3410c0-a40e-4b65-af3a-5cae1179d104_WhatsApp-Image-2026-04-19-at-13.02.33.jpeg?v=03984abba576550f3fed5f4edcb4087d",
    title: "Obra en Proceso",
    category: "Construcción",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/ae1f4e2f-42b7-4665-8dfb-80ebd44e06f0_WhatsApp-Image-2026-04-19-at-13.02.34.jpeg?v=7c03ede0631e14f017f16d61f20d6047",
    title: "Piscina Terminada",
    category: "Construcción",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/4ac39fd5-9c1d-4593-b54c-46719558ca76_WhatsApp-Image-2026-04-19-at-13.02.37.jpeg?v=feb2e02a02eb38ea77532533aadb37cd",
    title: "Agua Cristalina",
    category: "Mantenimiento",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/66344107-3c5d-4846-8618-950ff4ddaeb2_WhatsApp-Image-2026-04-19-at-13.02.39.jpeg?v=2440b40f7bf0d8100825265805578082",
    title: "Resultado Impecable",
    category: "Mantenimiento",
    type: "image" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/9c9e1d78-df75-40cd-b5b4-4901bd351160_WhatsApp-Video-2026-04-19-at-13.02.32.mp4?v=57477af81d89797f50514c31f5932639",
    title: "Proceso de Construcción",
    category: "Construcción",
    type: "video" as const,
  },
  {
    img: "https://storage.readdy-site.link/project_files/e71102c7-681c-4ff2-9943-5f1aa5eff95e/fd797b84-ee53-48ab-8486-1458a7ff634a_WhatsApp-Video-2026-04-19-at-13.02.39.mp4?v=d0c9297908f3463b4f1f70f503f0ed18",
    title: "Resultado Final",
    category: "Construcción",
    type: "video" as const,
  },
];
